const PRIMARY_COLOR = "#52565e";
const SECONDARY_COLOR = "#eef4ff";

const PRIMARY_BLUE_COLOR = "#cdd9ed";
const SECONDARY_BLUE_COLOR = "#a4adbd";

const PRIMARY_BLACK_COLOR = "#1d272d";

const BASIC_MOBILE_MEDIA_QUERY = `only screen and (max-width: 768px)`;

export {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  PRIMARY_BLUE_COLOR,
  PRIMARY_BLACK_COLOR,
  SECONDARY_BLUE_COLOR,
  BASIC_MOBILE_MEDIA_QUERY,
};
